import { render, staticRenderFns } from "./Whitelist.vue?vue&type=template&id=43191eed&"
import script from "./Whitelist.vue?vue&type=script&lang=js&"
export * from "./Whitelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43191eed')) {
      api.createRecord('43191eed', component.options)
    } else {
      api.reload('43191eed', component.options)
    }
    module.hot.accept("./Whitelist.vue?vue&type=template&id=43191eed&", function () {
      api.rerender('43191eed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/Whitelist.vue"
export default component.exports